import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

/** Apex CHARTS */
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

/** Bootstrap VUE */
import BootstrapVue from 'bootstrap-vue';
Vue.use(BootstrapVue)
Vue.config.productionTip = false

/** Style sheets */
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'font-awesome/css/font-awesome.css'
import 'prismjs/themes/prism.css'
import 'prismjs/themes/prism-dark.css'
import './assets/css/acolors.min.css'

new Vue({
  store,
  router,
  render: h => h(App)
  
}).$mount('#app')
